<img src="../../../../../assets/images/SPACE AR small.png" style="width:100px;margin-left:20px;"/>
<h1 mat-dialog-title>Update Primary Email Address</h1>
<div mat-dialog-content style="position:relative;top:-60px;">
   
  <form 
    (ngSubmit)="onSubmitUpdateEmailAddress()" 
    novalidate
    [formGroup]="updateEmailForm" 
    
    style="margin-top:20px;">
    <div class="row margin-top:20px;">
        <div class="col-12">
            <mat-form-field appearance="fill" style="width:100%">
                <mat-label>Email Address</mat-label>
                <input matInput placeholder="Email Address" formControlName="emailAddress" autocomplete="chrome-off">
                <mat-error>The Email address is required</mat-error>
            </mat-form-field>
        </div>
       
    </div>

    <!-- 20241011 :: Ken Moss - changed button caption from Submit to Update.  Backlog Issue: https://aceparking.backlog.com/board/L2?selectedIssueKey=L2-391 -->
    <button type="submit" class="btn btn-primary mt-3 ace-blue" style="margin-left:0px;" [disabled]="!updateEmailForm.valid">Update</button>
    </form>
       
</div>
<div mat-dialog-actions>
  <button mat-button [mat-dialog-close]="false" >Cancel</button>
</div>
